import Vue from 'vue'
import App from './App.vue'
import router from './router'
import IconSvg from '@/components/iconSvg'
import waterfall from 'vue-waterfall2'
import './iconfont.js'

Vue.config.productionTip = false
Vue.use(waterfall)
Vue.component('icon-svg', IconSvg)
new Vue({
  router,
  render: h => h(App)
}).$mount('#app')

router.beforeEach((to, from, next) => {
  if (from.meta.keepAlive) {
    const scrollTop = window.scrollY || 0;
    from.meta.scrollTop = scrollTop;
  }
  next()
})